import React from 'react';
import AreaDetailPage from './AreaDetailPage';
import { golfAreas } from '../data/mapData';

function GolfArea({ area }) {
  const config = golfAreas[area] || golfAreas.cart;
  return <AreaDetailPage config={config} sectionHeader="Golf Course" />;
}

export default GolfArea;
